import { Box } from "@chakra-ui/react"
import { NavLink } from "react-router-dom"

type Props = React.PropsWithChildren<{
  to: string
  exact?: boolean
}>

// Design system tab (tabs.css): 12px semibold uppercase; active tab in black, black 2px underline.
export const NavTab: React.FC<Props> = ({ children, to, exact }) => (
  <NavLink to={to} end={exact}>
    {({ isActive }) => (
      <Box
        pt={3}
        pb={4}
        mb="-1px"
        fontSize="2xs"
        fontWeight="semibold"
        letterSpacing="wider"
        textTransform="uppercase"
        whiteSpace="nowrap"
        color={isActive ? "text" : "textSubtle"}
        borderBottom="2px solid"
        borderBottomColor={isActive ? "text" : "transparent"}
        transitionProperty="color"
        transitionDuration="240ms"
        _hover={{ color: "text" }}
      >
        {children}
      </Box>
    )}
  </NavLink>
)
